<template>
  <layout-content>
    <div :is="current_component" />
  </layout-content>
</template>

<script>
  import { SenderService } from '@mailer/services/SenderService';
  import MailingCreateForm from '@mailer/components/mailings/mailings-create-form';
  import MailingNotSendersPage from '@mailer/pages/mailing-not-senders-page';

  export default {
    data: () => ({
      current_component: null
    }),
    created() {
      this.moderaion_senders();
    },
    methods: {
      moderaion_senders() {
        SenderService.getSelect()
          .then((response) => {
            const senders = response;

            if (senders && senders?.filter(sender => sender.status === "active")?.length > 0) {
              this.current_component = MailingCreateForm;
            } else {
              this.current_component = MailingNotSendersPage;
            }
          })
          .catch(() => {
            this.current_component = MailingNotSendersPage;
          });
      }
    }
  };
</script>
